/*
  出現アニメーションの発火

  .c-reveal を持つ要素が画面下15%のラインを越えたら c-reveal--in-view を付ける。
  値の根拠は docs/デザインルール.md の第7節。

  実装仕様
  #1 初期状態で隠すクラス c-reveal-ready は layout/theme.liquid のインラインスクリプトが
     付ける。ここで付けると defer の実行までに一瞬見えてしまうため
  #2 一度出したら監視を外す。戻って消える挙動は参考サイトに無かった
  #3 .c-reveal--staggered には --c-reveal-index を振って順に出す。
     親ごとに振り直すので、セクションをまたいで遅延が積み上がらない
  #4 shopify:section:load で再初期化する。テーマエディタでセクションを
     編集したとき、新しいDOMが隠れたままになるのを防ぐ
  #5 IntersectionObserver が無い環境では全部出したままにする
*/
(function () {
  'use strict';

  var READY_CLASS = 'c-reveal-ready';
  var IN_VIEW = 'c-reveal--in-view';
  var SELECTOR = '.c-reveal';
  var observer = null;

  function reveal(el) {
    el.classList.add(IN_VIEW);
  }

  function setup(root) {
    var targets = (root || document).querySelectorAll(SELECTOR + ':not(.' + IN_VIEW + ')');

    if (!targets.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      document.documentElement.classList.remove(READY_CLASS);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            reveal(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -15% 0px' }
      );
    }

    var staggerIndex = new Map();

    targets.forEach(function (el) {
      if (el.classList.contains('c-reveal--staggered')) {
        var parent = el.parentElement;
        var next = staggerIndex.has(parent) ? staggerIndex.get(parent) + 1 : 0;

        staggerIndex.set(parent, next);
        el.style.setProperty('--c-reveal-index', String(next));
      }

      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup(document);
    });
  } else {
    setup(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
